import noop from "lodash/noop.js";

/* eslint-disable no-console */
var warn = noop;
if (process.env.NODE_ENV !== 'production') {
  warn = function warn() {
    console.group('%cMisconfigured Union analytics', 'font-size: 16px;color:red');
    console.log('Global analytics is not configured correctly.');
    console.log('Please follow the instructions here: https://docs.union.theknot.com/docs/packages/@xo-union/tk-analytics"');
    console.groupEnd();
  };
}
var createWrapper = function createWrapper(fnName) {
  var wrapper = function wrapper() {
    if (globalThis.analytics) {
      var _globalThis$analytics;
      (_globalThis$analytics = globalThis.analytics)[fnName].apply(_globalThis$analytics, arguments);
    } else {
      warn();
    }
  };
  return wrapper;
};
export default {
  track: createWrapper('track'),
  alias: createWrapper('alias'),
  identify: createWrapper('identify'),
  reset: createWrapper('reset')
};